import { ModelosListSearchComponent } from './ModelosListSearchComponent'
import { ModelosListToolbar } from './ModelosListToolbar'

export const ModelosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <ModelosListSearchComponent actions={<ModelosListToolbar />} />
    </div>
  )
}
